import React, { useContext, useEffect } from 'react';
import AppContext from 'contexts/appContext';
import UserService from 'services/userService';

export default function AccountManage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Account, 'Manage Account');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Account', selected: true }]);
  }, []);

  return (
    <div className='container mt-3'>
      <h3><i className='icons8-user' /> {UserService.getUsername()}</h3>
      <hr />
      <h5>{UserService.getUserFullName()}</h5>
      <h5>{UserService.getUserEmail()}</h5>
    </div>
  );
}